"use client";

import React from "react";
import { X, Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * RealEstateWebsite — Section 2: Problem-Lösung-Split
 * Drop-in für: src/pages/RealEstateWebsite/sections/ProblemSolution.tsx
 */

const problems = ["Nur auf Portalen = austauschbar unter Hunderten", "Keine eigene Marke = kein Wiedererkennungswert", "Verpasste Direktanfragen und Bewertungsaufträge"];
const solutions = ["Eigene Marke & Domain statt Portal-Profil", "Objekte mit Bildergalerie & Details präsentieren", 'Lokale SEO für „Immobilien + [Ihre Region]"'];
export default function ProblemSolution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-5xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6 leading-tight">
              Ihre Kunden suchen online — nicht im Schaufenster
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Über 90 % der Immobiliensuchen beginnen im Internet. Ohne
              professionelle Website mit Ihren aktuellen Objekten verpassen Sie
              potenzielle Käufer und Mieter.
            </p>
            <ul className="space-y-4">
              {problems.map((p, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100 text-red-500 shrink-0">
                    <X className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{p}</span>
                </li>)}
            </ul>
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-primary mb-6 leading-tight">
              PAGEMAKER24 für Immobilien
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Ihre eigene Makler-Website — mit Objekt-Galerie, Ihrer Marke und
              direktem Kontaktformular. Professionell und in Minuten erstellt.
            </p>
            <ul className="space-y-4">
              {solutions.map((s, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 text-green-600 shrink-0">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{s}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}